import { ReactNode, MouseEvent } from "react";

interface SheetBackdropProps {
  onClose: () => void;
  labelledBy?: string;
  children: ReactNode;
  overlayClassName?: string;
  panelClassName?: string;
}

export default function SheetBackdrop({
  onClose,
  labelledBy,
  children,
  overlayClassName = "z-50 bg-black/50",
  panelClassName = "px-6 pb-6 pt-2",
}: SheetBackdropProps) {
  const handleOverlayClick = () => {
    onClose();
  };

  const stopInsideClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <div
      data-testid="sheet-backdrop"
      className={`fixed inset-0 flex items-end justify-center overflow-hidden ${overlayClassName}`}
      onClick={handleOverlayClick}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        className={`w-full max-w-[480px] bg-foreground rounded-t-2xl max-h-[90vh] flex flex-col overflow-hidden animate-slide-up ${panelClassName}`}
        onClick={stopInsideClick}
      >
        {children}
      </div>
    </div>
  );
}
